type ThumbnailAsset = {
  assetName: string;
  imgType: 'png' | 'jpg' | 'jpeg' | 'webp';
};

/*
 * This function is used to get the thumbnail URL from the CDN
 * @param thumbnail
 * @returns {string}
 */
export const getThumbnailUrlFromCDN = (thumbnail: ThumbnailAsset) => {
  const { assetName, imgType } = thumbnail;
  const thumbnailURL = process.env.REACT_APP_CDN_DOMAIN + `/media/e2-assets/${assetName}.${imgType}`;
  return thumbnailURL;
};
